import Vue from 'vue'
import SearchUser from '@/components/input/SearchUser'
import SearchTax from '@/components/input/SearchTax'
import SearchShipper from '@/components/input/SearchShipper'
import Search from '@/components/input/Search'
import Switch from '@/components/others/Switch'
import SwitchIf from '@/components/others/SwitchIf'
import Camera from '@/components/others/Camera'

Vue.component('search-user', SearchUser)
Vue.component('search-tax', SearchTax)
Vue.component('search-shipper', SearchShipper)
Vue.component('search', Search)
Vue.component('search-user', SearchUser)
Vue.component('app-switch', Switch)
Vue.component('app-switch-if', SwitchIf)
Vue.component('camera', Camera)

export default {}